module.exports = __webpack_public_path__ + "static/img/dot.7401ae6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-four/dot.png
// module id = O8Y2
// module chunks = 0